import { UserGroup } from '@models';
import { MutationPayload } from './mutation-payload';

export interface UpdateProjectCommitteeResult {
  updateProjectCommittee: UpdateProjectCommitteePayload;
}

export interface UpdateProjectCommitteePayload extends MutationPayload {
  committee?: UserGroup;
}
